import { render, staticRenderFns } from "./freeBenchmark.vue?vue&type=template&id=4b7f740e&scoped=true&"
import script from "./freeBenchmark.vue?vue&type=script&lang=js&"
export * from "./freeBenchmark.vue?vue&type=script&lang=js&"
import style0 from "./freeBenchmark.vue?vue&type=style&index=0&id=4b7f740e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f740e",
  null
  
)

export default component.exports